module.exports = __webpack_public_path__ + "static/media/check_access.d5bab03d.png";